import React from 'react';
export function BodorLeadsSection() {
  return <section data-id="element-3121">
      <div className="bg-[#1874cd] py-4 px-6 rounded-t-xl" data-id="element-3122">
        <h2 className="text-2xl md:text-3xl font-bold text-white text-center" data-id="element-3123">
          III. BODOR Leads The Laser Cutting Market Into The Era of 10kW+
        </h2>
      </div>
      <div className="bg-white p-8 rounded-b-xl shadow-sm border border-gray-200 border-t-0 space-y-8" data-id="element-3124">
        <ul className="list-disc list-inside space-y-3 text-gray-700 text-lg leading-relaxed" data-id="element-3125">
          <li data-id="element-3126">
            In 2019, Bodor delivered 2,700 laser cutting machines - the highest
            in the world.
          </li>
          <li data-id="element-3127">
            Prior to June 2020, Bodor Laser has sold more than 150 laser cutting
            machines with laser sources over 10kW - also the highest in the
            world
          </li>
          <li data-id="element-3128">
            On May 28, 2020, the first 20kW Bodor Laser Cutting Machine was
            delivered to the customer.
          </li>
          <li data-id="element-3129">
            By July 2020, the cumulative sales of 10kW+ laser cutting machines
            had exceeded 160 units. Bodor ranks first in the world for both
            production and sales, presenting evidence of product quality.
          </li>
          <li data-id="element-3130">
            Bodor provides a 3-year warranty and local after-sales service.
          </li>
        </ul>

        <hr className="border-gray-200" data-id="element-3131" />

        <div className="space-y-4" data-id="element-3132">
          <p className="text-gray-700 text-lg italic" data-id="element-3133">
            Additional product information linked below:
          </p>
          <div className="space-y-2" data-id="element-3134">
            <a href="/BodorLaserCutting.html" className="block text-xl font-bold text-navy hover:text-orange transition-colors" data-id="element-3135">
              Bodor High Power Fiber Laser Cutting Machines
            </a>
            <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-3136">
              <li data-id="element-3137">
                <a href="/BodorLaserCutting.html#Bodor_high_power_laser_cutting_machines" className="text-orange hover:underline font-bold text-lg" data-id="element-3138">
                  High Power
                </a>
              </li>
              <li data-id="element-3139">
                <a href="/BodorLaserCutting.html#high_precision_laser_cutting_machines" className="text-orange hover:underline font-bold text-lg" data-id="element-3140">
                  High Precision
                </a>
              </li>
              <li data-id="element-3141">
                <a href="/BodorLaserCutting.html#Laser_Tube_Cutting_Machines" className="text-orange hover:underline font-bold text-lg" data-id="element-3142">
                  Laser Tube Cutter
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}